<avd-code-example-header
    [packageName]="packageName"
    [getStartedLink]="getStartedLink"
    [storybookLink]="storybookLink"
    [repoLink]="repoLink"
></avd-code-example-header>

@for (example of examples; track example.variant) {
    <avd-code-example
        [label]="example.label"
        [description]="example.description"
        [htmlSnippet]="example.htmlSnippet"
    >
        <table uilab-mat-table [dataSource]="example.rows">
            <ng-container uilabMatColumnDef="name">
                <th uilab-mat-header-cell *uilabMatHeaderCellDef> Name </th>
                <td uilab-mat-cell *uilabMatCellDef="let row">
                    {{ row.name }}
                </td>
            </ng-container>

            <ng-container uilabMatColumnDef="owner">
                <th uilab-mat-header-cell *uilabMatHeaderCellDef> Owner </th>
                <td uilab-mat-cell *uilabMatCellDef="let row">
                    {{ row.owner }}
                </td>
            </ng-container>

            <ng-container uilabMatColumnDef="status">
                <th uilab-mat-header-cell *uilabMatHeaderCellDef> Status </th>
                <td uilab-mat-cell *uilabMatCellDef="let row">
                    {{ row.status }}
                </td>
            </ng-container>

            <tr
                uilab-mat-header-row
                *uilabMatHeaderRowDef="displayedColumns"
            ></tr>
            <tr
                uilab-mat-row
                *uilabMatRowDef="let row; columns: displayedColumns"
            ></tr>
        </table>
    </avd-code-example>
}
